export default class CloseTopicsMenu {
  constructor(context) {
    this.context = context;
  }

  run(params) {
    this.context.analytics.track('Topics Menu Closed', params);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/conversation/topics_menu/close_topics_menu.js